import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { ProgrammationDto } from '../store/programmation/programmation.models'
import { Colors } from '../constants/colors.constants';

import Arrow from '../assets/icons/Arrow.svg';
import ArrowYellow from '../assets/icons/ArrowYellow.svg';
import ArrowPurple from '../assets/icons/ArrowPurple.svg';

interface ProgCardProps {
  programmation: ProgrammationDto;
}

const ProgCard = (props: ProgCardProps) => {

  const { programmation } = props;

  return (
    <Stack
      gap={2}
      style={{
        borderRadius: '20px',
        border: '2px solid #000',
        color: '#000',
        textShadow: 'none'
      }}
      p={2}
      width='100%'>
      <Stack direction={{xs: 'column', md: 'row'}} justifyContent='space-between'>
        <Typography 
          fontSize={20}>
          {programmation.date} - {programmation.location}
        </Typography>
        <Typography  fontSize={20}>{programmation.time}</Typography>
      </Stack>
      <Stack gap={1}>
        <Typography  fontFamily='DroulersClarendon-Line'>{programmation.types}</Typography>
        <Stack>
          {programmation.artists.map((it, index) => (
            <Stack key={index} direction='row' gap={1} flexWrap='nowrap'>
              <Typography
                fontSize={{xs: 16, md: 22}}>
                  {it.name}
              </Typography>
             {it.type && (
              <Typography
                fontSize={14}
                fontFamily={'DroulersClarendon-Line'}>
                {`(${it.type})`}
              </Typography>)}
            </Stack>
          ))}
        </Stack>
      </Stack>
      <Stack direction='row' alignItems='center' justifyContent={'space-between'} gap={{xs: 0, md: 2}}>
        <Typography>
          {programmation.price ? programmation.price : ''}
        </Typography>
        <Stack sx={{
          flex: 1,
          backgroundColor: '#000',
          height: '1px',
          width: '100%',
          visibility: { xs: 'hidden', md: 'visible'} }} />
        {programmation.link && (
          <Button
            onClick={() => {
              window.location.href = programmation.link || ''
            }}
            sx={{
              textTransform: 'uppercase',
              border: '2px solid #000',
              backgroundColor: '#000',
              color: '#F9423A',
              paddingLeft: '10px',
              paddingRight: '10px',
              borderRadius: '10px',
              fontWeight: 700,
              transform: 'rotate(-1.5deg)',
              boxShadow: '6px 6px 0 0 #000',
              xs: { width: '150px', maxWidth: '150px', fontSize: '14px' },
              md: { width: '250px', fontSize: '22px', maxWidth: '250px', minWidth: '250px' },
              '&:hover': {
                backgroundColor: '#000',
                color: '#F9423A'
              }
            }}
            >Réserver
          </Button>
          )}

      </Stack>
    </Stack>
  )
}

export default ProgCard;